import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { parseCookiesFromString } from '@hyundai/shared-lib';
import { REQUEST, RESPONSE } from '../providers/express.token';

@Injectable({
    providedIn: 'root',
})
export class CookieService {
    protected readonly document = inject(DOCUMENT);
    protected readonly platformId = inject(PLATFORM_ID);
    protected readonly request = inject(REQUEST, { optional: true });
    protected readonly response = inject(RESPONSE, { optional: true });

    get(name: string): string | undefined {
        return this.parseCookies()[name];
    }

    has(name: string): boolean {
        return !!this.get(name);
    }

    getAll(): Record<string, string> {
        return this.parseCookies();
    }

    set(name: string, value: string, expireDays: number, path = '/', crossSite = false): void {
        if (isPlatformBrowser(this.platformId)) {
            const expires = new Date();
            expires.setTime(expires.getTime() + expireDays * 24 * 60 * 60 * 1000);
            this.document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=${path}${crossSite ? '; SameSite=None; Secure' : ''}`;
            return;
        }
        this.response?.cookie(name, value, {
            maxAge: expireDays * 24 * 60 * 60 * 1000,
        });
    }

    delete(name: string): void {
        this.set(name, '', 0);
    }

    protected parseCookies(): Record<string, string> {
        const cookies: Record<string, string> = {};
        const cookieString = isPlatformBrowser(this.platformId)
            ? this.document.cookie
            : this.request?.header('cookie') || '';

        if (!cookieString) {
            return cookies;
        }

        return parseCookiesFromString(cookieString);
    }
}
